import { useEffect, useState } from "react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

let cache = null;
export const useModels = () => {
  const [models, setModels] = useState(cache || []);
  useEffect(() => { if (cache) return; api.get("/models").then((r) => { cache = r.data; setModels(r.data); }).catch(() => {}); }, []);
  return models;
};
export const modelLabel = (id, models) => models.find((m) => m.id === id)?.label || id;

export const ModelSelect = ({ value, onChange, disabled, testid = "ai-model-select", className = "" }) => {
  const models = useModels();
  const providers = [...new Set(models.map((m) => m.provider))];
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testid} className={className}><SelectValue placeholder="AI model" /></SelectTrigger>
      <SelectContent className="max-h-80">
        {providers.map((p) => (
          <SelectGroup key={p}>
            <SelectLabel className="text-[10px] uppercase tracking-wider text-slate-500">{models.find((m) => m.provider === p)?.provider_label}</SelectLabel>
            {models.filter((m) => m.provider === p).map((m) => (
              <SelectItem key={m.id} value={m.id} data-testid={`ai-model-option-${m.id.replace(/[:.]/g, "-")}`}>{m.label}{m.recommended ? " · recommended" : ""}</SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};
